<p-confirmDialog
  [style]="{ width: '420px' }"
  acceptButtonStyleClass="p-button-danger"
  rejectButtonStyleClass="p-button-outlined p-button-secondary">
</p-confirmDialog>

<div class="ts-page">

  <!-- Page Header -->
  <div class="ts-header">
    <!-- <span class="ts-header__icon">
      <i class="pi pi-calendar"></i>
    </span> -->
    <div>
      <p class="ts-header__sub">Search and delete timesheet entries by date range</p>
    </div>
  </div>

  <!-- Search Panel -->
  <p-card styleClass="ts-search-card">
    <ng-template pTemplate="header">
      <div class="ts-card-header">
        <i class="pi pi-search"></i>
        <span>Search Timesheets</span>
      </div>
    </ng-template>

    <form [formGroup]="searchForm" (ngSubmit)="onSearch()" novalidate>
      <div class="ts-form-row">

        <!-- Start Date -->
        <div class="ts-field">
          <label class="ts-label" for="startDate">
            Start Date <span class="ts-required">*</span>
          </label>
          <p-calendar
            inputId="startDate"
            formControlName="startDate"
            dateFormat="dd/mm/yy"
            placeholder="DD/MM/YYYY"
            styleClass="ts-calendar"
            appendTo="body"
            [ngClass]="{ 'ng-invalid ng-dirty': searchForm.get('startDate')?.invalid && searchForm.get('startDate')?.touched }">
          </p-calendar>
          <small class="ts-error"
            *ngIf="searchForm.get('startDate')?.invalid && searchForm.get('startDate')?.touched">
            Start date is required.
          </small>
        </div>

        <!-- End Date -->
        <div class="ts-field">
          <label class="ts-label" for="endDate">
            End Date <span class="ts-required">*</span>
          </label>
          <p-calendar
            inputId="endDate"
            formControlName="endDate"
            dateFormat="dd/mm/yy"
            placeholder="DD/MM/YYYY"
            styleClass="ts-calendar"
            appendTo="body"
            [ngClass]="{ 'ng-invalid ng-dirty': searchForm.get('endDate')?.invalid && searchForm.get('endDate')?.touched }">
          </p-calendar>
          <small class="ts-error"
            *ngIf="searchForm.get('endDate')?.invalid && searchForm.get('endDate')?.touched">
            End date is required.
          </small>
        </div>

        <!-- Action Buttons -->
        <div class="ts-field ts-field--actions">
          <label class="ts-label ts-label--hidden">Actions</label>
          <div class="ts-btn-group">
            <p-button
              type="submit"
              label="Search"
              icon="pi pi-search"
              [loading]="isLoading">
            </p-button>
            <p-button
              type="button"
              label="Reset"
              icon="pi pi-refresh"
              severity="secondary"
              outlined="true"
              (onClick)="onReset()">
            </p-button>
          </div>
        </div>

      </div>

      <small class="ts-error ts-error--form"
        *ngIf="searchForm.errors?.['dateRangeInvalid'] && searchForm.touched">
        <i class="pi pi-exclamation-circle"></i>
        End date must be on or after start date.
      </small>
    </form>
  </p-card>

  <!-- Results Grid -->
  <p-card *ngIf="hasSearched" styleClass="ts-grid-card">
    <ng-template pTemplate="header">
      <div class="ts-card-header ts-card-header--between">
        <div class="ts-card-header__left">
          <i class="pi pi-list"></i>
          <span>Results</span>
        </div>
        <!-- <span pBadge [value]="count" severity="info"></span> -->
      </div>
    </ng-template>
  
    <p-table #dt [value]="timesheets" [loading]="isLoading" [paginator]="timesheets.length > 10" [rows]="10"
      [rowsPerPageOptions]="[10, 25, 50]" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
      [globalFilterFields]="['ProjectName','TaskName','TimesheetDate','RecordStatus']"
      styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped ts-table" responsiveLayout="scroll"
      emptyMessage="No timesheet records found for the selected date range.">
  
      <!-- Global search toolbar -->
      <!-- <ng-template pTemplate="caption">
            <div class="ts-table-toolbar">
                <span class="p-input-icon-left ts-search-input">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="Filter records…" />
                </span>
            </div>
        </ng-template> -->
  
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="ProjectName">
            Project Name <p-sortIcon field="ProjectName"></p-sortIcon>
          </th>
          <th pSortableColumn="TaskName">
            Task Name <p-sortIcon field="TaskName"></p-sortIcon>
          </th>
          <th pSortableColumn="TimesheetDate">
            Timesheet Date <p-sortIcon field="TimesheetDate"></p-sortIcon>
          </th>
          <th pSortableColumn="RecordStatus">
            Record Status <p-sortIcon field="RecordStatus"></p-sortIcon>
          </th>
          <th style="text-align:center; width:110px">Action</th>
        </tr>
        <tr>
          <th>
            <p-columnFilter type="text" field="ProjectName" display="row">
            </p-columnFilter>
          </th>
  
          <th>
            <p-columnFilter type="text" field="TaskName" display="row">
            </p-columnFilter>
          </th>
  
          <th>
            <p-columnFilter type="text" field="TimesheetDate" display="row">
            </p-columnFilter>
          </th>
  
          <th>
            <p-columnFilter type="text" field="RecordStatus" display="row">
            </p-columnFilter>
          </th>
  
          <th></th>
        </tr>
      </ng-template>
  
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>
            <!-- <span class="ts-project-name">
                  <i class="pi pi-folder-open ts-project-icon"></i> -->
            {{ row.ProjectName }}
            <!-- </span> -->
          </td>
          <td>{{ row.TaskName }}</td>
          <td>{{ row.TimesheetDate }}</td>
          <td>
            <!-- <p-tag
                  [value]="row.recordStatus"
                  [severity]="getStatusSeverity(row.recordStatus)">
                </p-tag> -->
            {{row.RecordStatus}}
          </td>
          <td style="text-align:center">
            <p-button icon="pi pi-trash" label="Delete" severity="danger" outlined="true" size="small"
              (onClick)="confirmDelete(row)" [attr.aria-label]="'Delete timesheet for ' + row.ProjectName">
            </p-button>
          </td>
        </tr>
      </ng-template>
  
    </p-table>
    <div *ngIf="!isLoading && hasSearched && timesheets.length === 0"
        style="text-align:center; padding: 40px 16px; color: #6b7280;">
      <div style="display:flex; flex-direction:column; align-items:center; gap:8px;">
        <i class="pi pi-calendar-times" style="font-size:2rem; color:#d1d5db;"></i>
        <span>No timesheet records found for the selected date range.</span>
      </div>
    </div>
  </p-card>

</div>
<p-toast />
<app-loader [showLoader]="showLoader"></app-loader>